import { CreditCardData } from 'design-system';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { PaymentDataFields } from '../../../../../store/emissionPolicy/slice/emissionPolicySlice';
import EmissionDataFields from '../../../../helperTypes/EmissionDataFields';
import ACHData from '../../../../helperTypes/ACHData';
import ClaveData from '../../../../helperTypes/ClaveData';
import RequestClaveData from '../../../RequestClaveData';
import {
  PaymentShape,
  CreditCardData as RequestCreditCardData,
  ACHData as RequestACHData,
  makeEmptyCreditCard,
  makeEmptyACHData,
} from '../../../EmissionRequest';

import {
  creditCard as creditCardPaymentType,
  achPayment,
  PaymentLegacy,
  clavePayment,
} from '../../../../../constants/paymentTypes';

// Functions
import catalogItemForCode from '../../../../../functions/catalogItemForCode';
import parsePaymentType from './parsePaymentType';

export default function parseCreditCard(
  paymentAmount: number,
  paymentFields: PaymentDataFields,
  dataFields: EmissionDataFields,
  creditCardData: CreditCardData,
  achData: ACHData,
  banks: GeneralCatalogItem[],
  claveData: ClaveData,
): PaymentShape {
  const [monthString, yearString] = creditCardData.expirationDate.split('/');

  const cardNumber = creditCardData.cardNumber.replace(/\s/g, '');

  const { type } = paymentFields;
  const { cardName, cardType, securityCode, bankEntityCode, cardAddress } =
    creditCardData;
  const { email, phoneNumber } = dataFields;

  /** Avoid null values during parseInt */
  const expirationMonth = parseInt(monthString, 10);
  const expirationYear = parseInt(`20${yearString}`, 10);

  /** Extract the correct bank information based on the catalog */
  const { name: bankDescription } = catalogItemForCode(bankEntityCode, banks);

  const creditCard: RequestCreditCardData = {
    cardNumber,
    nameOwner: cardName,
    expirationMonth,
    expirationYear,
    securityCode,
    cardType,
    emailOwner: email,
    phoneNumberOwner: phoneNumber,
    addressOwner: cardAddress,
    bankId: bankEntityCode,
    bankDescription,
  };

  const achDataOutput: RequestACHData = {
    accountName: achData.accountOwnerName,
    accountNumber: achData.accountNumber,
    accountType: achData.accountType,
    bankId: achData.accountBankId,
  };

  const claveDataOutput: RequestClaveData = {
    sessionId: claveData.sessionId,
  };

  let output: PaymentShape;

  if (type === clavePayment) {
    output = {
      amount: paymentAmount,
      claveData: claveDataOutput,
      paymentMethod: type,
    };
  } else {
    /**
     * If payment method is either remmittance or direct, or a broker is involved
     * then creditCardData should be emptied
     */
    output = {
      amount: paymentAmount,
      creditCard:
        type !== creditCardPaymentType ? makeEmptyCreditCard() : creditCard,
      achData: type === achPayment ? achDataOutput : makeEmptyACHData(),
      paymentMethod: parsePaymentType(type) as PaymentLegacy,
    };
  }

  return output;
}
